import { render, staticRenderFns } from "./AddressCompanyForm.vue?vue&type=template&id=7a0b13b6&scoped=true&"
import script from "./AddressCompanyForm.vue?vue&type=script&lang=js&"
export * from "./AddressCompanyForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a0b13b6",
  null
  
)

export default component.exports